
function loadPage(component, path = '') {
  // '@' is aliased to src/module
  let importPath = (path) ? path + '/' : '';
  return () => import(`@/components/page/` + importPath + `${component}.vue`)
}

const routes_base = [
  {path: 'delivery/product/create', component: loadPage('DeliveryProductCreate', 'delivery/product')},
  {path: 'delivery/product', component: loadPage('DeliveryProductList', 'delivery/product')},
  {path: 'delivery/order/detail', component: loadPage('OrderDetail', 'delivery/order')},
  {path: 'delivery/order_list_order', component: loadPage('OrderListOrder', 'delivery/order')},
  {path: 'delivery/order_list_pay_new', component: loadPage('OrderListPayNew', 'delivery/order')},
  {path: 'delivery/order_list_pay_all', component: loadPage('OrderListPayAll', 'delivery/order')},
  {path: 'delivery/order_create', component: loadPage('OrderCreate', 'delivery/order')},
  {path: 'delivery/order_list_goods_new', component: loadPage('OrderListGoodsNew', 'delivery/goods')},
  {path: 'delivery/order_list_goods_all', component: loadPage('OrderListGoodsAll', 'delivery/goods')},
  {path: 'delivery/order_list_delivery_new', component: loadPage('OrderListDeliveryNew', 'delivery/delivery')},
  {path: 'delivery/order_list_deliverying', component: loadPage('OrderListDeliverying', 'delivery/delivery')},
  {path: 'delivery/order_list_delivery_all', component: loadPage('OrderListDeliveryAll', 'delivery/delivery')},
  {path: 'delivery/order_list_delivery_success', component: loadPage('OrderListDeliverySuccess', 'delivery/delivery')},
  {path: 'delivery/order_list_settle', component: loadPage('OrderListSettle', 'delivery/delivery')},
  {path: 'delivery/order_list_cancel_new', component: loadPage('OrderListCancelNew', 'delivery/cancel')},
  {path: 'delivery/order_list_cancel_all', component: loadPage('OrderListCancelAll', 'delivery/cancel')},
  {path: 'delivery/order_list_back_new', component: loadPage('OrderListReturnNew', 'delivery/return')},
  {path: 'delivery/order_list_back_all', component: loadPage('OrderListReturnAll', 'delivery/return')},
  {path: 'delivery/order_list_backing', component: loadPage('OrderListReturning', 'delivery/return')},
  {path: 'delivery/order_list_refund_new', component: loadPage('OrderListRefundNew', 'delivery/refund')},
  {path: 'delivery/order_list_refund_all', component: loadPage('OrderListRefundAll', 'delivery/refund')},
  {path: 'delivery/order_list_exchange_new', component: loadPage('OrderListExchangeNew', 'delivery/exchange')},
  {path: 'delivery/order_list_exchange_all', component: loadPage('OrderListExchangeAll', 'delivery/exchange')},
  {path: 'delivery/order_list_exchanging', component: loadPage('OrderListExchanging', 'delivery/exchange')},
  {path: 'delivery/order_list_exchange_success', component: loadPage('OrderListExchangeSuccess', 'delivery/exchange')},
  {path: 'delivery/order_list_exchange_goods', component: loadPage('OrderListExchangeGoods', 'delivery/exchange')},
  {path: 'delivery/order_list_exchange_delivery_new', component: loadPage('OrderListExchangeDeliveryNew', 'delivery/exchange')},
  {path: 'delivery/order_list_exchange_delivery_all', component: loadPage('OrderListExchangeDeliveryAll', 'delivery/exchange')},
  {path: 'delivery/order_list_exchange_delivery_settle', component: loadPage('OrderListExchangeSettle', 'delivery/exchange')},
  {path: 'delivery/order_setting', component: loadPage('OrderSetting', 'delivery/order') },
  // 정산
  { path: 'delivery/account/new', component: loadPage('AccountNew', 'delivery/account') },
  { path: 'delivery/account/all', component: loadPage('AccountAll', 'delivery/account') },
  { path: 'delivery/account/setting', component: loadPage('AccountSetting', 'delivery/account') },

  // 포인트
  { path: 'delivery/point/setting', component: loadPage('PointSetting', 'point') },

];


const routes_admin = [

];


const routes = {
  'base': routes_base,
  'admin': routes_admin.concat(routes_base)
};

export default routes;

